module.exports = __webpack_public_path__ + "img/capacitor-blue.b3929bf3.webp";